import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class OrderHistory extends Mixins(CommonView) {
    // kurukuru: boolean = false;
    // pnkzList: {name: string, path: string | null}[] = [{name: "TOP", path: "/"}, {name: "マイページ", path: "/mypage"}, {name: "購入履歴", path: null}];
    // public error: string = "";

    // public orderHistoryList: BASEAPI.OrderHistory[] = [];

    // public async created() {
    //     if (await this.isLoginRedirect(true)) return;
        
    //     await this.init();

    // }

    // @Watch('$route')
    // public async init() {
    //     if (await this.isLoginRedirect(true)) return;

    //     this.kurukuru = true;
    //     this.orderHistoryList = [];

    //     let res = await BASEAPI.OrderHistoryController.getOrderHistoryListUsingGET().catch(AxiosErrorHandler);
    //     if (isAxiosError(res)) {
    //         this.error = "" + res.data;
    //         return;
    //     }
    //     this.orderHistoryList = res.data;
        
    //     this.kurukuru = false;
    // }
}
